module.exports = __webpack_public_path__ + "img/GazelEnergie_120X35.6ed9de65.png";